import styled from 'styled-components';
import Autocomplete from 'react-google-autocomplete';
import background from '../../images/LunexPower.webp';
import { IoMdLocate } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import { FiPlus } from 'react-icons/fi';
import { FiMinus } from 'react-icons/fi';
import { CgProfile } from 'react-icons/cg';
import { motion } from 'framer-motion';

export const QuoteOuterContainer = styled.div`
    font-family: 'Avenir_Book';
`;


export const TopBar = styled.div`
    height: 70px;
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    position: fixed;
    z-index: 5;
    display: flex;
    flex-direction: row;

    /* The bar itself still spans the window — a capped white strip would leave
       a seam on a wide monitor — but its contents line up with QuoteGrid, so
       the logo sits above the page rather than off in the corner. */
    padding-left: max(0px, calc((100% - 1180px) / 2));
    padding-right: max(0px, calc((100% - 1180px) / 2));

    @media screen and (max-width: 900px) {
        height: 50px;
    }
`;

export const LunexHeaderLogo = styled.img`
    height: 60px;
    width: auto;
    /* margin-top: 5px; */
    margin-left: 10px;
    @media screen and (max-width: 900px) {
        height: ${({customer}) => (customer ? `60px` : `30px`)};
        margin-top: 10px;
    }
`;

export const LunexHeaderLogoH1 = styled.img`
    height: auto;
    width: 100%;
    margin-left: 50px;
    margin-right: 50px;
    max-width: 450px;
    /* margin-top: 5px; */
    /* margin-left: 10px; */
    /* @media screen and (max-width: 900px) {
        height: ${({customer}) => (customer ? `60px` : `30px`)};
        margin-top: 10px;
    } */
`;

export const ProfileWrapper = styled.div`
    position: absolute;
    right: 0;
`

export const NavbarLogout = styled.div`
    color: #1BA8F1;
    position: absolute;
    bottom: 28px;
    right: 60px;

    @media screen and (max-width: 500px) {
        bottom: 19px;
        right: 40px;
    }

    &:hover {
        color: #ffa500;
    }
`

export const LoginLink = styled.div`
    font-size:25px;
    margin: 20px;
    color: #1BA8F1;
    text-decoration: none;
    @media screen and (max-width: 500px) {
        font-size:15px;
        margin: 15px;
    }

    &:hover {
        color: #ffa500;
    }
`

export const ProfileIcon = styled(CgProfile)`
    font-size:37px;
    margin: 15px;
    color: #1BA8F1;
    @media screen and (max-width: 500px) {
        font-size:25px;
        margin: 12px;
    }

    &:hover {
        color: #ffa500;
    }

`
export const QuoteInnerContainer = styled.div`
  width: 100%;
  height: 100vh; // Full viewport height to make it fixed
  display: flex;
  /* align-items: center;
  justify-content: center; */
  margin: 0 auto;
  /* padding-top: 200px; */

  @media screen and (max-width: 900px) {
    height: auto;
  }
`;

export const QuoteGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: 1fr;
  gap: 20px;
  width: 100%;
  height: 100%;
  /* The right column is a fixed 380px card, so without a cap the left column
     absorbs every extra pixel of a wide monitor and the story panel stretches
     to a couple of thousand pixels of unreadable line length. */
  max-width: 1180px;
  margin: 0 auto;

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    gap: 0;
  }
`;

export const AnimationContainer = styled.div`
    display: flex;
    align-items: center;
`

export const ScrollAnimationWrapper = styled.div`
  height: calc(100% - 80px);
  width: auto;
  margin: 0 auto;
  margin-left: 10px;
  margin-top: 70px;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);

  @media screen and (max-width: 900px) {
    display: ${({$design}) => ($design ? `none` : `block`)};
    /* height: 300px; */
    width: 95%;
    height: auto;
    margin: 0 auto;
    margin-top: 70px;
    max-height: 320px;
    max-width: 380px;
    /* overflow: auto; */
  }

  @media screen and (min-width: 2285px) {
    margin: 0 auto;
    margin-top: 70px;
  }
`;

export const QuoteBg = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({design}) => (design ? `calc(100% - 180px)` : `calc(100% - 80px)`)}; 
  width: auto;
  margin-left: 20px;
  padding-top: 70px;
  border-radius: 10px;
  overflow: hidden;

  @media screen and (max-width: 900px) {
    height: auto;
    width: 95%;
    padding-top: 60px;
    margin: 0 auto;
    max-width: 440px;
  }
`;

export const ImageBg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-image: ${({ backgroundImage }) => backgroundImage ? `url(${backgroundImage})` : `url(${background})`};
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 10px;

  @media screen and (max-width: 900px) {
    display: block;
    width: 100%;
    height: auto;
  }
`;

/**
 * The intake rail — Locate and Customer.
 *
 * A white card with a hairline border, matching the package hero and the
 * customize panel on the Design page. It used to be a 20px-radius slab of
 * #f8f4f4, which was the only warm grey left in the flow and read as a
 * different product from the screen it hands off to.
 */
export const QuoteInnerWrapper = styled.div`
  width: 400px;
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  flex-direction: column;
  justify-content: flex-start;
  max-width: 400px;
  /* Hug the form. As a stretched grid item the card ran the full height of the
     row, which with the product picker gone is mostly empty white. */
  align-self: start;
  margin: 70px 10px 10px auto;
  padding: 28px 26px 32px;
  position: relative;
  border: 1px solid #e0e6ea;
  border-radius: 12px;
  background-color: #fff;
  filter: ${({ $ispopupopen }) => ($ispopupopen ? 'blur(5px)' : 'none')};
  opacity: ${({ $ispopupopen }) => ($ispopupopen ? '0.6' : '1')};
  pointer-events: ${({ $ispopupopen, disabled }) => ($ispopupopen || disabled ? 'none' : 'auto')};
  transition: filter 0.3s ease, opacity 0.3s ease;

  display: ${({ $ispopupopen }) => ($ispopupopen ? 'none' : 'flex')};

  @media screen and (max-width: 900px) {
    width: 95%;
    height: auto;
    max-height: none;
    overflow-y: unset;
    order: 2;
    margin: 30px auto 0;
    padding: 24px 18px 28px;
  }
`;

export const CustomerInnerWrapper = styled.div`
  width: 100%;
  max-height: 100%;
  max-width: 360px;
  margin: 0 auto;
  margin-right: 35px;
  margin-top: 80px;
  padding-bottom: 40px;
  padding-left: 10px;
  padding-right: 35px;
  position: relative;
  overflow-y: auto;

  @media screen and (max-width: 900px) {
    width: 90%;
    max-height: 100%;
    height: auto;
    padding-right: 10px;
    order: 2;
    margin: 0 auto;
  }
`;

export const QuoteBgMobile = styled.div`
    display: none;
    @media screen and (max-width: 900px) {
        display: flex;
        transition: all 0.2s ease-in-out;
    }
`;

export const ImageBgMobile = styled.img`
    @media screen and (max-width: 900px) {
        width:100%;
        height: 200px;
        object-fit: cover;
    }
    
`;

export const QuoteOuterWrapper = styled.div`
    

`;

export const QuoteBackgroundWrapper = styled.div`
    
`;


/**
 * The step's headline. Left-aligned now: the rail is a form, and centred
 * headings over left-aligned labelled fields left the whole column looking
 * like it had two different margins.
 */
export const QuoteHeader = styled.h1`
    text-align: left;
    font-size: 1.55rem;
    line-height: 1.15;
    letter-spacing: -0.01em;
    font-weight: 800;
    color: #0f1b24;
    margin: 0;
`;

export const QuoteHeader2 = styled.h2`
    margin: 32px 0 0;
    text-align: left;
    color: #0f1b24;
    font-size: 1.05rem;
    font-weight: 800;
`;

/* The line under a headline — what this step is asking for. */
export const QuoteHeader3 = styled.h5`
    text-align: left;
    color: #41545f;
    font-size: 0.85rem;
    line-height: 1.55;
    font-weight: 400;
    margin: 8px 0 0;
`;

/* The eyebrow above a headline: LUNEX DIRECT / STEP 1 OF 3, and so on. */
export const QuoteEyebrow = styled.div`
    font-size: 0.62rem;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: #0b7fbd;
    font-weight: 700;
    margin-bottom: 10px;
`;

/* The stack of labelled fields, so the markup no longer spaces itself with <br />. */
export const QuoteFieldStack = styled.div`
    display: grid;
    gap: 20px;
    margin-top: 26px;
`;

const fieldStyles = `
    background-color: #fff;
    box-sizing: border-box;
    border: 1px solid #e0e6ea;
    border-radius: 8px;
    transition: border-color 140ms ease, box-shadow 140ms ease;
    width: 100%;
    height: 46px;
    font-family: inherit;
    font-size: 0.95rem;
    font-weight: 500;
    color: #0f1b24;
    padding: 0 34px 0 13px;
    text-overflow: ellipsis;

    &::placeholder {
        color: #a9bcc8;
        font-weight: 400;
    }

    &:hover {
        border-color: #cfdde6;
    }

    &:focus {
        outline: none;
        border-color: #1ba8f1;
        box-shadow: 0 0 0 3px rgba(27, 168, 241, 0.16);
    }
`;

export const QuoteAutocomplete = styled(Autocomplete)`
    ${fieldStyles}
`;

/* The micro-label above a field, matching the row labels on the Design page. */
export const QuoteInputTitle = styled.label`
    font-size: 0.6rem;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    font-weight: 800;
    color: #8098a8;
    display: block;
    text-align: left;
    margin-bottom: 8px;
`;

export const QuoteInputTitleCheckbox = styled.label`
    font-size: 1.5rem;
    font-weight: 100;
    color: #000;
    display: block;
    text-align: center;
    @media screen and (max-width: 480px) {
        font-size: 1.3rem;
    }

`;

export const StorageTitle = styled.label`
    font-size: 1.8rem;
    font-weight: 700;
    color: #000;
    display: block;
    text-align: center;
    padding: 20px;
`;

export const QuoteTextTitle = styled.label`
    font-size: 1.5rem;
    font-weight: 500;
    color: #000;
    display: block;
    text-align: center;
    margin-top: auto;
    margin-bottom: auto;
`;

export const QuoteTextSubtitle = styled.label`
    font-size: 0.72rem;
    line-height: 1.55;
    font-weight: 400;
    color: #8098a8;
    display: block;
    text-align: left;
`;

export const QuoteLeaseNumber = styled.span`
    font-size: 2.5rem;
    font-weight: bold;
    position: relative;
    bottom: -5px;
    color: #1BA8F1; /* This is a bright blue color, but you can adjust to any other blue you prefer */
`;

export const QuoteLink = styled.a`
    font-size: 1rem;
    font-weight: 200;
    color: #000;
    display: block;
    text-align: center;
`;

export const QuoteTextTotalWrapper = styled.div`
    margin: auto;
    width:80%;
    display: flex;
    flex-direction: row;
`

export const QuoteDropdownTotalWrapper = styled.div`
    margin-left: auto;
    margin-right: auto;
    width:85%;
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
    justify-content: center;
`

export const QuoteTextTotalFirst = styled.div`
    font-size: 1.3rem;
    text-align: left;
    margin-right: 0;
    margin-top: auto;
    margin-bottom: auto;

`

export const QuoteTextTotalLast = styled.div`
    font-size: 1.3rem;
    margin-left: auto;
    margin-right: 0;
`

export const QuoteTextTotalFirstItalic = styled.div`
    font-size: 1.3rem;
    text-align: left;
    margin-right: 0;
    margin-top: auto;
    margin-bottom: auto;
    font-style: italic;

`

export const QuoteTextTotalLastItalic = styled.div`
    font-size: 1.3rem;
    margin-left: auto;
    margin-right: 0;
    font-style: italic;
`

export const QuoteTotalLeaseNumber = styled.span`
    font-size: 2.5rem;
    font-weight: bold;
    color: #1BA8F1;
`

export const DownloadLink = styled.a`
    font-size: 1rem;
    font-weight: 200;
    color: #000;
    display: block;
    text-align: center;
    text-decoration-line: underline;
    text-decoration-color: black;
    text-align: center;
`;

/**
 * Holds a field and the icon that sits inside its right edge.
 *
 * position: relative is the point. The locate/clear icons are absolutely
 * positioned and this wrapper had no positioning of its own, so they were
 * anchoring to the whole rail — right: 15px happened to land inside the field
 * only because the rail was a fixed 380px wide.
 */
export const QuoteAddressWrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const QuoteInputWrapper = styled.div`
    width: 100%;
    margin: auto;
    display: block;
`;

export const QuoteTextWrapper = styled.div`
    width: 100%;
    margin: 18px auto 0;
    padding-top: 16px;
    border-top: 1px solid #eaf0f4;
`;

export const QuoteRemoveWrapper = styled.div`
    width: 300px;
    background-color: ${({selected}) => (selected ? 'rgba(255,165,0,0.5)' : '#fff')};
    transition: all 0.2s ease-in-out;
    border-radius: 10px;
    padding: 15px;
    margin: auto;
    display: block;
`;

export const QuoteInput = styled.input`
    ${fieldStyles}
`;

export const QuoteAppendedText = styled.span`
  position: absolute;
  right: 13px;
  font-size: 0.8rem;
  font-weight: 700;
  color: #8098a8;
  pointer-events: none;
`;

export const QuoteInputCheckbox = styled.input`
    background-color: #E8E8E8;
    border-radius: 5px;
    width: 15px;
    height: 15px;
    margin-left: 10px;
    @media screen and (max-width: 480px) {
        /* margin-bottom: 10px; */
        /* width: 97%; */
    }
`;

const fieldIconStyles = `
    position: absolute;
    right: 11px;
    height: 20px;
    width: 20px;
    color: #8098a8;
    cursor: pointer;
    transition: color 140ms ease;

    &:hover {
        color: #1ba8f1;
    }
`;

export const QuoteInputLocateIcon = styled(IoMdLocate)`
    ${fieldIconStyles}
`;

export const QuoteInputDeleteIcon = styled(IoMdClose)`
    ${fieldIconStyles}
`;

export const EnergyUsageColumn = styled.div`
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
    align-items: center;
    justify-content: center;
    flex: 1;
`

export const EnergyWrapper = styled.div`
    margin: auto;
    width: 80%;
`;

export const GridWrapper = styled.div`
    margin: 10px;
`;

export const GridRow = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    /* max-width:200px; */
    width: 100%;
`;

export const GridColumn = styled.div`
    display: flex;
    background-color: ${({selected}) => (selected ? 'rgba(255,165,0,0.5)' : '#fff')};
    transition: all 0.2s ease-in-out;
    border-radius: 15px;
    max-width: 220px;

    flex-direction: column;
    flex-basis: 100%;
    align-items: center;
    justify-content: center;
    flex: 1;
    margin: 10px;
`;

export const CounterWrapper = styled.div`
    display: flex;
    flex-direction: row;
    border-radius: 50px;
    border: 2px solid black;
`;

export const CounterMotion = styled(motion.div)`
    
`

export const CounterMinusIcon = styled(FiMinus)`
    height:28px;
    margin: 7px;
    color: ${({disabled}) => (disabled ? '#808080' : '#000')};

`;

export const CounterPlusIcon = styled(FiPlus)`
    height:28px;
    margin: 7px;
    color: ${({disabled}) => (disabled ? '#808080' : '#000')};
`;

export const CounterNumber = styled.div`
    font-size: 20px;

    margin: 6px;
    color: #000;
`;

export const SolarImages = styled.img`
    height:300px;
    width: 180px;
`

export const BatteryImages = styled.img`
    width: 180px;
    height: auto;
`;

export const TextWrapper = styled.div`
    margin: auto;
    width: 80%;
`;

export const TextCentered = styled.div`
    font-size: 1rem;
    color: grey;
    text-align: center;
`

export const IncentiveLine = styled.div`
    margin: auto;
    width: 80%;
    border-bottom: 1px solid grey;
`;

export const IncentiveText = styled.div`
    font-size: 1rem;
    color: grey;
`

export const CaptchaContainer = styled.div`
    margin: auto;
    align-items: center;
    width: 300px;
    padding-bottom:5px;
`;

export const ButtonContainer = styled.div`
    margin: 26px auto 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
`;

export const LoadingWrapper = styled.div`
    height: 200px;
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
`

export const CreditCardWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    height: 150px;
`

export const NextButton = styled.button`
    border-radius: 8px;
    width: ${({$small}) => ($small ? '70px' : '100%')};
    min-height: 50px;
    border: 0;
    background: #1BA8F1;
    white-space: nowrap;
    padding: 14px 24px;
    color: #fff;
    font-size: 0.78rem;
    font-weight: 800;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    outline: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: background 160ms ease, color 160ms ease;
    font-family: inherit;
    margin-left: auto;
    margin-right: auto;

    &:disabled {
        background: #eef3f6;
        color: #a9bcc8;
        pointer-events: none;
    }

    &:hover {
        background: #0b7fbd;
        color: #fff;
    }

    &:focus-visible {
        outline: 2px solid #1ba8f1;
        outline-offset: 2px;
    }
`;

export const RemoveButton = styled.button`
    border-radius: 50px;
    border: 2px solid white;
    background: #ff0000;
    white-space: nowrap;
    padding: 12px 30px;
    color: #fff;
    font-size: 16px;
    outline: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;
    font-family: 'Avenir_Book';
    margin-left: auto;
    margin-right: auto; 
    &:disabled {
        background: #808080;
        pointer-events: none;
    }
    &:hover {
        transition: all 0.2s ease-in-out;
        background: #ffa500;
        color: #fff;
    }
`;

export const RegistrationErrorWrapper = styled.div`
    width: 100%;
    text-align: center;
    margin: 12px auto 0;
    display: block;
    font-size: 0.78rem;
    color: #8098a8;

    /* ErrorText left-aligns so it can sit under a field; centre it here, where
       it is a full-width notice under the button rather than a field error. */
    & > div {
        text-align: center;
    }
`

export const ErrorWrapper = styled.div`
    width: 100%;
    margin: auto;
    display: block;
`

export const ErrorText = styled.div`
    color: #c9444d;
    font-size: 0.75rem;
    line-height: 1.5;
    margin-top: 8px;
    text-align: left;
`

export const RemeberMeWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    text-align: center;
`

export const RememberMeText = styled.div`
    color: #000;
    font-size: 0.75rem;
    margin-top: 0.25rem;
`

export const RememberMeCheckbox = styled.input`
    margin-top: 8px;
`

/**
 * The customer's address, shown as a quiet eyebrow rather than a control.
 *
 * Shared by the design page's top row and the pricing popup's header so the two
 * cannot drift apart. It replaced an underlined, orange-on-hover pseudo-link
 * that reset the whole flow back to the address screen when clicked — an
 * expensive action to leave sitting under a label that only meant to say which
 * house these numbers are for.
 *
 * `min-width: 0` so it actually ellipsizes: as a flex child it would otherwise
 * refuse to shrink below its text and push its row wider instead.
 */
export const AddressEyebrow = styled.div`
    font-size: 0.6rem;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    font-weight: 800;
    color: #8098a8;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;



export const BackButton = styled.div`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  background-color: transparent;
  color: #8098a8;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  cursor: pointer;
  padding-bottom: 5px;
  margin-bottom: 14px;
  transition: color 140ms ease;

  &:hover {
    color: #0b7fbd;
  }
`;

export const Arrow = styled.span`
  margin-right: 8px;
`;